import { Group } from "@visx/group";
import { InfraEventPassengerCount } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/AreaChart/types";
import type {
  DateScale,
  ValueScale,
} from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/AreaChart/types";
import {
  getDate,
  getValue,
} from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/AreaChart/utils";
import { CHART_CONFIG } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/AreaChart/constants";
import { FC } from "react";
import { useTheme } from "styled-components";

interface DataPointsProps {
  data: InfraEventPassengerCount[];
  dateScale: DateScale;
  valueScale: ValueScale;
}

export const DataPoints: FC<DataPointsProps> = ({
  data: chartData,
  dateScale,
  valueScale,
}) => {
  const theme = useTheme();

  return (
    <Group>
      {chartData.map((d) => {
        const cx = dateScale(getDate(d));
        const cy = valueScale(getValue(d));
        const pointKey = `${d.date.getTime()}-${d.passengers}`;

        return (
          <circle
            key={pointKey}
            cx={cx}
            cy={cy}
            r={CHART_CONFIG.marker.pointRadius}
            fill={theme.colorSuccess}
          />
        );
      })}
    </Group>
  );
};
